import { render, staticRenderFns } from "./SetPeople.vue?vue&type=template&id=4a78a08b&scoped=true&"
import script from "./SetPeople.vue?vue&type=script&lang=js&"
export * from "./SetPeople.vue?vue&type=script&lang=js&"
import style0 from "./SetPeople.vue?vue&type=style&index=0&id=4a78a08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a78a08b",
  null
  
)

export default component.exports